// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__background__off {
  from {
    background: var(--av-background-color, var(--background-color));
  }
  to {
    background: var(--background-color);
  }
}
@keyframes avMode__background__on {
  from {
    background: var(--background-color);
  }
  to {
    background: var(--av-background-color, var(--background-color));
  }
}
.av-mode.av-mode__background {
  background: var(--background-color);
}
.av-mode.av-mode__background.av-mode__off {
  animation: 1.2s avMode__background__off forwards;
}
.av-mode.av-mode__background.av-mode__off .product-badges .product-badge {
  background-color: var(--color-background);
}
.av-mode.av-mode__background.av-mode__on {
  animation: 1.2s avMode__background__on forwards;
}
.av-mode.av-mode__background.av-mode__on .product-badges .product-badge {
  color: #7cffb7;
  background-color: var(--av-color-background);
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__background.scss","webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__vars.scss"],"names":[],"mappings":"AAUA;EACE;IARA,+DAAA;EAAA;EAYA;IARA,mCAAA;EADA;AACF;AAaA;EACE;IAdA,mCAAA;EAIA;EAcA;IAtBA,+DAAA;EAWA;AACF;AAgBE;EAxBA,mCAAA;AAWF;AAgBI;EACE,gDAAA;AAdN;AAiBQ;EACE,yCAAA;AAfV;AAoBI;EACE,+CAAA;AAlBN;AAqBQ;EACE,cC/Cc;EDgDd,4CAAA;AAnBV","sourcesContent":["@import './av-mode__vars.scss';\n\n@mixin on() {\n  background: var(--av-background-color, var(--background-color));\n}\n\n@mixin off() {\n  background: var(--background-color);\n}\n\n@keyframes avMode__background__off {\n  from {\n    @include on;\n  }\n\n  to {\n    @include off;\n  }\n}\n\n@keyframes avMode__background__on {\n  from {\n    @include off;\n  }\n\n  to {\n    @include on;\n  }\n}\n\n.av-mode {\n  &.av-mode__background {\n    @include off;\n\n    &.av-mode__off {\n      animation: $animation-duration avMode__background__off forwards;\n\n      .product-badges {\n        .product-badge {\n          background-color: var(--color-background);\n        }\n      }\n    }\n\n    &.av-mode__on {\n      animation: $animation-duration avMode__background__on forwards;\n\n      .product-badges {\n        .product-badge {\n          color: $av-mode-switch--color;\n          background-color: var(--av-color-background);\n        }\n      }\n    }\n  }\n}","$animation-duration: 1.2s;\n\n$av-mode-switch--color: #7cffb7; \n$av-mode-switch--cicle-animation-duration: 0.2s;\n$av-mode-switch--background-off: #7cffb7; \n$av-mode-switch--background-on: white; \n$av-mode-switch--cicle-size: 28px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
